import React from 'react';
import diagram1 from '../assets/centralized-trading-hub-img-1.webp';
import diagram2 from '../assets/centralized-trading-hub-img-2.webp';
const CentralizedTradingHub = () => {
    return (
        <section className="w-full bg-[#F1F1F1] py-20 px-4 md:px-8">
            <div className="max-w-[1271px] mx-auto">
                {/* Header Text Box */}
                <div className="text-center mb-16 md:mb-24 max-w-5xl mx-auto">
                    <h2 className="font-oswald text-black text-3xl md:text-5xl font-bold uppercase leading-tight mb-6">
                        FGC TMS: A CENTRALIZED TRADING, <br className="hidden md:block" />
                        OPERATIONS AND COMPLIANCE HUB
                    </h2>
                    <p className="font-inter text-gray-600 text-lg md:text-xl leading-relaxed max-w-4xl mx-auto">
                        FGC TMS consolidates your entire trading and post-trade world into a single system system, transforming your team from a manual and fragmented crews into proactive problem solvers and a well coordinated task force.
                    </p>
                </div>

                {/* Diagram Image */}
                <div className="w-full flex justify-center mb-24 md:mb-32">
                    <img
                        src={diagram1}
                        alt="FGC TMS Centralized Trading Hub Diagram"
                        className="w-full h-auto md:px-10 max-w-full"
                        loading="lazy"
                    />
                </div>

                {/* Diagram Image */}
                <div className="w-full flex justify-center mb-12 md:mb-32">
                    <img
                        src={diagram2}
                        alt="FGC TMS Centralized Trading Hub Diagram"
                        className="w-full h-auto md:px-10 max-w-full"
                        loading="lazy"
                    />
                </div>

                {/* Footer Quote */}
                <div className="text-center md:pb-10">
                    <p className="font-inter text-gray-700 text-lg md:text-2xl font-medium">
                        "Transform your team into an efficient, coordinated fixed income trading team."
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CentralizedTradingHub;
